import Vuex from 'vuex'
import Vue from 'vue'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
    plugins: [createPersistedState({
        storage: window.localStorage,
    })],
    state: {

        logged: false, //accesso effettuato

        partition: '', //partizione corrente

        oratore: null, //oratore connesso

        congregazione: null, //congregazione connesso

        idCircoscrizione: null, //idCircoscrizione corrente
        circoscrizione: null, //circoscrizione corrente
        idCongregazione: null, //congregazione corrente
        congregazioneCorrente: null, //congregazione corrente

        externalCirc: false, // circoscrizione extra selezionata

        externalCong: false, // congregazione extra selezionata

        loginCodice: 0,
        loginInputCodice: 0, // codice numerico digitato al login (v[0] di "codice-partition")

        isCollaboratore: false,

        listaProgrammi: [],

        talkShards: [], // [{ name, appId }] — caricato dal server al boot
    },

    mutations: {
        logout(state) {
            state.logged = false;
        },
        login(state) {
            state.logged = true;
        },
        setCircoscrizione(state, circoscrizione) {
            state.circoscrizione = circoscrizione;
        },
        // Nuova mutazione per impostare tutti i dati di login
        setLoginState(state, payload) {
            state.accessToken = payload.accessToken;
            state.partition = payload.partition;
            state.oratore = payload.oratore;
            state.congregazione = payload.congregazione;
            state.idCircoscrizione = payload.idCircoscrizione;
            state.idCongregazione = payload.idCongregazione;
            state.congregazioneCorrente = payload.congregazioneCorrente;
        },
        updateCongregazione(state, nuovaCongregazione) {
            state.idCongregazione = nuovaCongregazione.id;
            state.congregazioneCorrente = nuovaCongregazione;
            if (state.oratore) {
                state.oratore = { ...state.oratore, congregazione: nuovaCongregazione };
            }
        },
        updateOratore(state, oratore) {
            if (state.oratore && oratore) {
                state.oratore = { ...state.oratore, ...oratore };
            }
        },
        setTalkShards(state, shards) {
            state.talkShards = shards;
        },
    },

    actions: { 
        logout(context) {
            context.commit('logout')
        },
        login(context) {
            context.commit('login')
        }
    }
});
